<template>
  <Modal
    :enableMainAction="enableMainAction"
    :handleMainAction="handleMainAction"
    :headerText="headerText"
    :loading="loading"
    :mainActionText="mainActionText"
    :visible="visible"
    @updateVisibility="handleUpdateVisibilityChanged"
  >
    <slot />
    <form :class="$style.fileUploadForm">
      <label :class="$style.label">
        <input
          ref="input"
          accept=".csv"
          type="file"
          @change="emitUploadedFile"
        >
        {{ label }}
      </label>
    </form>
  </Modal>
</template>
<script>
import Modal from 'client/components/Modal/Modal.vue';

export default {
  name: 'FileUploadModal',

  components: {
    Modal,
  },

  props: {
    cancelText: {
      default: 'cancel',
      type: String,
    },
    handleCancel: {
      default: () => {},
      type: Function,
    },
    handleMainAction: {
      default: () => {},
      type: Function,
    },
    headerText: {
      default: 'Select a File',
      type: String,
    },
    label: {
      default: '',
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    mainActionText: {
      default: 'upload',
      type: String,
    },
    visible: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      enableMainAction: false,
    };
  },

  watch: {
    visible() {
      /**
       * Disable the main action button when hidden so that it will be disabled
       * if the modal is re-opened.
      */
      if (!this.visible) {
        this.enableMainAction = false;
      }
    },
  },

  methods: {
    emitUploadedFile(e) {
      this.enableMainAction = true;
      this.$emit('fileSelected', e.target.files[0]);
    },

    handleUpdateVisibilityChanged(visibility) {
      if (visibility === false) {
        this.handleCancel();
      }
    },
  },
};
</script>

<style module>
@import '../FormValidation/css/formFields.css';

.fileUploadForm {
  margin-top: 2rem;
}
</style>
